import { render, staticRenderFns } from "./LogoExtraSettingsModal.vue?vue&type=template&id=63bbf8ac"
import script from "./LogoExtraSettingsModal.vue?vue&type=script&lang=ts"
export * from "./LogoExtraSettingsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63bbf8ac')) {
      api.createRecord('63bbf8ac', component.options)
    } else {
      api.reload('63bbf8ac', component.options)
    }
    module.hot.accept("./LogoExtraSettingsModal.vue?vue&type=template&id=63bbf8ac", function () {
      api.rerender('63bbf8ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/LogoExtraSettingsModal.vue"
export default component.exports